import * as actionTypes from './actionTypes';
import { userService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { isClientEnv } from '@app/src/utils/validations';
import { hydrateDataForSend } from './hydrators';
import { fetchValidateAccess } from '@app/src/common/session';

const createUserRequest = () => ({
  type: actionTypes.CREATE_USER_REQUEST
});

const createUserFailure = () => ({
  type: actionTypes.CREATE_USER_FAILURE
});

const createUserSuccess = (data) => ({
  type: actionTypes.CREATE_USER_SUCCESS,
  data
});

const putUserRequest = () => ({
  type: actionTypes.PUT_USER_REQUEST
});

const putUserFailure = () => ({
  type: actionTypes.PUT_USER_FAILURE
});

const putUserSuccess = (data) => ({
  type: actionTypes.PUT_USER_SUCCESS,
  data
});

export const setUserPasarella = (pasarellaType: string) => ({
  type: actionTypes.SET_USER_PASARELLA,
  pasarellaType
});

export const setUserName = (name: string) => ({
  type: actionTypes.SET_USER_NAME,
  name
});

export const setUserToken = (token: string) => ({
  type: actionTypes.SET_USER_TOKEN,
  token
});

export const setUserLogin = (isLogin: boolean) => ({
  type: actionTypes.SET_USER_LOGIN,
  isLogin
});

const isClient = isClientEnv();

export const createUser: Function = (json: any, isInitLogin: boolean) => {
  return async dispatch => {
    dispatch(createUserRequest());
    await dispatch(fetchValidateAccess());
    try {
      const formatData = hydrateDataForSend(json, isInitLogin);
      const data = await userService.post(formatData);
      dispatch(actionsModalError.openModalError(data.message));
      dispatch(createUserFailure());
      if (data && data.data && data.data.length > 0) {
        const currentData = data.data[0];
        dispatch(createUserSuccess(currentData));
        const user = JSON.parse(localStorage.getItem('user'));
        const updateUser = {
          ...user,
          email: json.email,
          jwt: currentData && currentData.jwt,
          isLogin: false
        }
        if (isClient) {
          localStorage.setItem('user', JSON.stringify(updateUser));
        }
      }
    } catch (error) {
      console.log(`Error createUser action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(createUserFailure());
    }
  }
};


export const putUser = (userId: number) => {
  return async dispatch => {
    dispatch(putUserRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await userService.put(userId);
      const currentData = data.data[0];
      dispatch(putUserSuccess(currentData));
      return currentData;
    } catch (error) {
      console.log(`Error createUser action ${error}`);
      dispatch(actionsModalError.openModalError('Ocurrió un error'));
      dispatch(putUserFailure());
    }
  }
};
